export const limitDigits = (
	raw: string,
	max: number,
	previous: string,
): string => {
	const digits = raw.replace(/\D/g, "");
	if (!digits) return "";
	if (Number(digits) <= max) return String(Number(digits));
	return previous.replace(/\D/g, "");
};
